import { ICopyable } from '../controls/common/icopyable';
import { EmailAttachment } from './email-attachment';
import { IEmailAttachment } from './interfaces/email-attachment.interface';
import { IEmailTemplate } from './interfaces/email-template.interface';
import { IEmail } from './interfaces/email.interface';

export class EmailTemplate implements ICopyable<IEmailTemplate> {
    id: number = null;
    organizationId: string = null;
    name: string = null;
    template: IEmail = null;
    predefinedAttachments: IEmailAttachment[];

    public createCopy(): EmailTemplate {
        const instance = new EmailTemplate();
        instance.id = this.id;
        instance.organizationId = this.organizationId;
        instance.name = this.name;
        instance.template = this.template;

        return instance;
    }

    public static createFormCopy(emailTemplate: EmailTemplate): IEmailTemplate {
        const instance = new EmailTemplate();
        instance.id = emailTemplate.id;
        instance.organizationId = emailTemplate.organizationId;
        instance.name = emailTemplate.name;
        instance.template = emailTemplate.template;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.organizationId = other.organizationId;
        this.name = other.name;
        this.template = other.template;
    }

    /**
     * Retourne une instance de FolderSatte à partir d'une instance de IFolderState.
     * @param other : Instance de IFolderState.
     * @returns : Instance de FolderState.
     */
    public static from(other: IEmailTemplate) {
        if (!!other) {
            const instance = new EmailTemplate();

            instance.id = other.id;
            instance.organizationId = other.organizationId;
            instance.name = other.name;
            instance.template = other.template;
            instance.template.predefinedAttachments = EmailAttachment.fromArray(other.template.predefinedAttachments);

            return instance;
        } else {
            return null;
        }
    }

    public getDisplayName() {
        return `${this.name}`;
    }
}
